// Carrusel de las franjas bl-*. Se apoya en scroll-snap nativo: el gesto tactil
// y el teclado ya funcionan sin JS, esto solo anade los botones y el contador.
// ponytail: un slide por vista. Si hace falta multi-item o autoplay, cambiar por libreria.
//
// El indice se lleva en JS y se mueve con scrollIntoView sobre el slide destino.
// Con scroll-snap-type: x mandatory un scrollBy relativo y suave se cancela a
// mitad y el snap lo devuelve al punto anterior: los botones no hacian nada.
// Se veia solo con mas de un slide, y hasta ahora todas las bandas tenian uno.
(function () {
  function init(root) {
    if (root.dataset.blSliderReady) return;
    root.dataset.blSliderReady = '1';

    var track = root.querySelector('[data-bl-track]');
    if (!track) return;

    var current = root.querySelector('[data-bl-current]');
    var prev = root.querySelector('[data-bl-prev]');
    var next = root.querySelector('[data-bl-next]');
    var i = 0;

    // Ultimo indice UTIL, no ultimo hijo. Cuando se ven varias tarjetas a la
    // vez —las 6 ventajas son 2 en movil y 3 en escritorio— los ultimos slides
    // comparten posicion final: la pista ya esta al tope y no se mueve mas.
    // Contando hijos, la flecha seguia activa y el contador subia solo.
    // Con un slide por vista da el mismo numero de siempre.
    function last() {
      var first = track.firstElementChild;
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var w = first.getBoundingClientRect().width + gap;
      var max = track.scrollWidth - track.clientWidth;
      if (!w || max <= 0) return 0;
      return Math.min(track.children.length - 1, Math.ceil(max / w));
    }

    function paint() {
      if (current) current.textContent = i + 1;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= last();
    }

    function go(n) {
      i = Math.max(0, Math.min(last(), n));
      var slide = track.children[i];
      if (slide) {
        // Salto instantaneo, a proposito. `scroll-snap-type: x mandatory`
        // CANCELA cualquier scroll suave: da igual que venga de scrollBy, de
        // scrollIntoView o de scrollTo({behavior:'smooth'}), y da igual que el
        // suave lo ponga el CSS o el JS — el snap devuelve la pista al punto
        // anterior y scrollLeft se queda en 0. Medido el 2026-08-11: los
        // botones pintaban el contador pero NINGUN carrusel se movia, ni este
        // ni el del antes/despues. Con salto instantaneo el snap no estorba.
        track.scrollTo({
          left: slide.offsetLeft - track.children[0].offsetLeft,
          behavior: 'auto'
        });
      }
      paint();
    }

    // el gesto tactil mueve el scroll sin pasar por go(): se recalcula el indice
    var t;
    function fromScroll() {
      clearTimeout(t);
      t = setTimeout(function () {
        var first = track.firstElementChild;
        if (!first) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var w = first.getBoundingClientRect().width + gap;
        if (!w) return;
        i = Math.max(0, Math.min(last(), Math.round(track.scrollLeft / w)));
        paint();
      }, 120);
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    track.addEventListener('scroll', fromScroll, { passive: true });
    window.addEventListener('resize', fromScroll);
    paint();
  }

  function initAll() {
    document.querySelectorAll('[data-bl-slider]').forEach(init);
  }

  initAll();
  // el editor de temas reinyecta secciones sin recargar la pagina
  document.addEventListener('shopify:section:load', initAll);
})();
